<template>

  <v-form
    class="login"
  >
    <v-text-field
      v-model="email"
      color="teal lighten-2"
      :error-messages="error['email']"
      label="Email"
      required
      outline
      clearable
      dark
      prepend-inner-icon="fas fa-user fa-sm"
      class="theme round"
    />
    <v-text-field
      v-model="password"
      :error-messages="error['password']"
      label="Password"
      type="password"
      color="teal lighten-2"
      required
      clearable
      outline
      dark
      prepend-inner-icon="fas fa-lock fa-sm"
      class="theme round"
    />
    <router-link
      to="/recovery"
      class="pl-4 white--text"
    >
      Forgot password?
    </router-link>
    <br>
    {{ error['detail'] }}
    <br>
    <div @click="login">
      <BottomPanel button-text="Log in" />
    </div>
  </v-form>
</template>

<script>
  import { mapGetters } from 'vuex';
  import BottomPanel from "./BottomPanel";


  export default {
    name: 'LoginForm',
    components: {
      BottomPanel
    },
    data() {
      return {
        email: '',
        password: ''
      }
    },
    computed: {
      ...mapGetters(
        'authentication', ['status', 'error'],
        )
    },
    methods: {
      login: function () {
        const { email, password } = this;
        this.$store.dispatch('authentication/login', { email, password });
      },
    },
    mounted: function () {
      this.$nextTick(function () {
        this.$store.dispatch('authentication/clearErrors');
      })
    }
  }
</script>

<style scoped>
  .login__title {
    position: relative;
    font-weight: bold;
    padding-bottom: 15px;
    margin: 50px 0 50px 0;
  }

  .login__title::after {
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    content: '';
    width: 50px;
    height: 1px;
    background-color: #fff;
  }
</style>

